import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Container, Row } from 'react-bootstrap';
import EditArticleForm from './article-edit-form';
import BackLink from '../../../../common/back-link/index';
import PageTitle from '../../../../common/page-title/index';
import { getArticle } from '../../../../../actions/news';
import { getAllGroups } from '../../../../../actions/groups';
import { getAbmCodes } from '../../../../../actions/brands';

class EditArticle extends Component {
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    const id = +this.props.match.params.id;
    dispatch(getAbmCodes());
    dispatch(getAllGroups(true)).then(() => {
      dispatch(getArticle(id)).then(() => {
        dispatch(actions.resetValidity('deep.admin_news.article'));
      });
    });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.admin_news.article'));
    dispatch({ type: 'CLEAR_EDIT_NEWS_ARTICLE' });
  }

  render() {
    return (
      <Container fluid className="articles">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/news/articles"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Add/Edit article
            </PageTitle>
            <EditArticleForm
              article={this.props.article}
              categoryList={this.props.categoryList}
              linkArticles={this.props.articleList}
              abmCodes={this.props.abmCodes}
              permissions={this.props.permissions}
              statusList={this.props.statusList}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  article: state.news.articles.article,
  abmCodes: state.abm_codes.abm_codes,
  fetched: state.news.articles.fetched,
  fetching: state.news.articles.fetching,
  articleList: state.news.articles.editorInput.articles,
  statusList: state.news.articles.editorInput.statuses,
  categoryList: state.news.articles.editorInput.categories,
  permissions: state.news.articles.editorInput.permissions,
});

export default connect(mapStateToProps)(EditArticle);
